// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"108":"2fb87faf578ce26bf807","245":"aea6fb167f723922232a","452":"990d6cbbb15acb69ced8","453":"8f8694e8ab3b62de9f69"}[chunkId] + ".js";
};